import React, { useState } from 'react'
// import { useParams } from 'react-router-dom'
import ProjectContent from '../components/Projects/EachProject/ProjectContent'
import AdditionalContent1 from '../components/Projects/EachProject/MoreContent/AdditionalContent1'
import ProjectCommentsSection from '../components/Projects/EachProject/CommentSection/ProjectCommentsSection'
import Footer from '../layout/Footer'
import FlowChart from '../components/Projects/EachProject/AIFlowChart/FlowChart'
import RoleApplication from '../components/Projects/EachProject/AIFlowChart/RoleApplication'

function EachProject() {

    const [currentView, setCurrentView] = useState(1)

    // const {project_id, node_index} = useParams()
 function toggleView(index){
    setCurrentView(index)
 }


  return (
    <>
          <div className='my-8 py-5 mx-3 sm:mx-6 lg:mx-8 text-white'>

          <div className='flex flex-col md:flex-row'>

          <div className='w-full md:w-[70%] bg-[#101010] mb-12 md:px-4 lg:px-8 py-5'>
              <div className='bg-[#827777] rounded-t-md text-center flex justify-between w-full md:w-1/4 md:mt-3'>
                  <button 
                  className={`${currentView === 1 ? "bg-[#101010] md:bg-blackCustom"
                                                  : currentView === 2 ? "bg-[#4C4747]" 
                                                  : currentView === 3 && "md:bg-blackCustom"
                                } 
                  w-1/3 md:w-1/2 py-4 px-2.5 rounded-tl-md `}
                  onClick={() => toggleView(1)}>
                  Post</button>

                  <button 
                  className={`${currentView === 2 ? "bg-[#101010]" : "bg-[#4C4747]" } md:hidden w-1/3 py-4 px-2.5 `}
                  onClick={() => toggleView(2)}>Thread</button>

                  <button 
                  className={`${currentView === 3 && "bg-[#101010] md:bg-[#242424]" } w-1/3 md:w-1/2 py-4 px-2.5 `}
                  onClick={() => toggleView(3)}>AI FlowChart</button>
              </div>

              {currentView === 1 ?
              <div className='md:bg-blackCustom md:scroll-bar-in-dark md:h-screen md:overflow-y-scroll py-6 px-4 sm:px-8'>
              <ProjectContent />
              </div>

              : currentView === 2 ?
              <div className='md:hidden py-6 px-4 sm:px-8'>
                <ProjectCommentsSection />
              </div>

              : currentView === 3 &&

              <div className='py-6 px-4 sm:pl-8 md:bg-[#242424] h-screen overflow-y-scroll scroll-bar-in-dark'>
                  <div className='flex flex-col lg:flex-row lg:justify-between md:px-3'>
                  <div className='lg:w-[57%]'>
                  <FlowChart />
                  </div>
                  <div className='lg:w-2/5'>
                  <RoleApplication />
                  </div>
                  </div>
              </div>
              }
              

              </div>

              <div className='md:scroll-bar-in-dark md:h-[116vh] md:overflow-y-scroll w-full md:w-[30%] 
              bg-[#101010] rounded-md py-6 md:pb-[60px] my-5 md:my-0 px-4'>
                <AdditionalContent1 />
              </div>
          </div>


          <div className='bg-[#101010] md:block hidden py-6 px-4 sm:px-8'>
                <ProjectCommentsSection />
          </div>

          </div>
          <Footer />
    </>
  )
}

export default EachProject
